import { useState } from "react";
import "./Brand.css";
import SideModal from "./SideModal";

function Brand() {
  const [brands, setBrands] = useState([
    { id: 1, name: "Apple" },
    { id: 2, name: "Samsung" },
    { id: 3, name: "Sony" },
  ]);

  const [open, setOpen] = useState(false);
  const [brandName, setBrandName] = useState("");
  const [editId, setEditId] = useState(null);

  const saveBrand = () => {
    if (!brandName.trim()) return;

    if (editId) {
      setBrands(
        brands.map((item) =>
          item.id === editId
            ? { ...item, name: brandName }
            : item
        )
      );
    } else {
      setBrands([
        ...brands,
        {
          id: Date.now(),
          name: brandName,
        },
      ]);
    }

    setBrandName("");
    setEditId(null);
    setOpen(false);
  };

  const editBrand = (item) => {
    setBrandName(item.name);
    setEditId(item.id);
    setOpen(true);
  };

  const deleteBrand = (id) => {
    if (window.confirm("Delete this brand?")) {
      setBrands(brands.filter((item) => item.id !== id));
    }
  };

  return (
    <div className="page">

      <div className="topBar">
        <h2>Brand Management</h2>

        <button
          className="addBtn"
          onClick={() => {
            setBrandName("");
            setEditId(null);
            setOpen(true);
          }}
        >
          + Add Brand
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Brand Name</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>

          {brands.map((brand, index) => (

            <tr key={brand.id}>

              <td>{index + 1}</td>

              <td>{brand.name}</td>

              <td>

                <button
                  className="edit"
                  onClick={() => editBrand(brand)}
                >
                  Edit
                </button>

                <button
                  className="BrandDelete"
                  onClick={() => deleteBrand(brand.id)}
                >
                  Delete
                </button>

              </td>

            </tr>

          ))}

        </tbody>
      </table>

      <SideModal
        open={open}
        close={() => setOpen(false)}
      >
        <h3>{editId ? "Edit Brand" : "Add Brand"}</h3>

        <input
          type="text"
          placeholder="Brand Name"
          value={brandName}
          onChange={(e) => setBrandName(e.target.value)}
        />

        <button
          className="saveBtn"
          onClick={saveBrand}
        >
          Save
        </button>

      </SideModal>

    </div>
  );
}

export default Brand;